<template>
  <div class="my-table userPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('activation.txt1')}}</span>
        <span>{{$t('activation.txt2')}} / {{$t('activation.txt3')}}</span>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{$t('activation.txt3')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="onBack">{{$t('activation.txt4')}}</div>
          <div class="searchBtn" @click="confirmActivation('activationForm')">{{$t('activation.txt5')}}</div>
        </div>
      </div>
      <div class="editForm passwordForm">
        <el-form :model="activationForm" :rules="activationRules" ref="activationForm" label-width="100px" class="demo-ruleForm">
          <el-form-item :label="$t('activation.txt6')" prop="effectDate">
            {{activationForm.effectDae}}
            <el-date-picker
            v-model="activationForm.effectDate"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            :start-placeholder="$t('activation.txt8')"
            :end-placeholder="$t('activation.txt9')">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        activationForm:{
          effectDate:'',
          id:this.$route.query.id
        },
        // 激活规则
        activationRules: {
          effectDate: [
          { required: true, message: this.$t('activation.txt10'), trigger: 'change' },
          ],
        },
      };
    },
    created() {
    },
    methods: {
      onBack(){
        this.$router.go(-1);
      },
    // 确认激活
    confirmActivation(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let id = this.activationForm.id;
          this.freeze(2,id);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
      // 用户冻结/解冻
      async freeze(statusType,idData){
        let data = {};
        if(statusType == 2){
          data = {
            freeze:statusType,
            id:idData,
            startDate:this.activationForm.effectDate[0],
            endDate:this.activationForm.effectDate[1],
          }
        }else{
          data = {
            freeze:statusType,
            id:idData
          }
        }
        const { data: res } = await this.$http.post("/user/info/freeze?"+qs.stringify(data));
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.$message({
          type: 'success',
          message: this.$t('activation.txt11')
        });
        this.onBack();
      },
    },
  };
</script>

<style lang="less" scoped>

  .handleBtn{
    padding: 0;
  }
  .userPage{
    /deep/ .el-upload__input{
      display: none !important;
    }
    /deep/ .el-date-editor .el-range-separator{
      margin-top: -5px;
      width: 8%;
    }
    .contactTitle{
      margin-bottom: 40px;
    }
    .contactTitle span{
      margin-right: 30px;
      cursor: pointer;
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .w350{
      width: 350px;
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    .passwordForm{
      width: 50%;
      margin: 30px auto 260px auto;
      display: block;
    }
  }

</style>
